// frontend/src/features/tbs/regions.js
// Ordered list of regions taken from the Texas Storm Chasers map legend.
// Edit the order here if you want the UI sections to move.
export const REGION_ORDER = [
  "North Texas",
  "Texoma",
  "Northeast Texas",
  "East Texas",
  "Central Texas",
  "Hill Country",
  "South-Central Texas",
  "Southeast Texas",
  "Golden Triangle",
  "Coastal Bend",
  "Coastal Plains",
  "Brazos Valley",
  "West Texas",
  "Panhandle",
  "Permian Basin",
  "Northwest Texas",
  "Borderland",
  "Trans-Pecos",
  "Rio Grande Plains",
  "Rio Grande Valley",
  "Concho Valley",
  "Big Country",
  "Edwards Plateau",
  "Big Bend",
  "Other / Special",
];
